<h2 mat-dialog-title>Potential Negative Balances Confirmation</h2>
<mat-dialog-content class="mat-typography">
  <span style="font-size:18px;">The following {{pendingInvoiceList.length}} of {{totalNumberOfPayments}} payment(s) will result in the invoice having a negative balance once the payment is applied:</span>
  
 

  <div class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;">
    <table style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;"> 
      <tr  class="grid-headers">
        <th style="width:150px;">Invoice Number</th>
        <th  style="width:150px;">Payment Amount</th>
        <th  style="width:300px;">Invoice Balance After Payment</th>
      </tr>
    
        <tr *ngFor="let anInvoice of pendingInvoiceList;let i = index" style="margin-bottom:20px;" class="grid-rows">
                <td style="margin-left:5px;width:300px;">
                    {{anInvoice.invoiceNumber}}
                </td>
                <td style="margin-left:5px;width:200px;">
                    {{anInvoice.paymentAmount | currency}}
                </td>
                <td style="margin-left:5px;width:200px;color:red;">
                    {{anInvoice.newBalance | currency}}
                </td>
        </tr>
        </table>    
  </div>
  <h4 style="margin-top:25px;">Click Continue to apply payment(s)</h4>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-light btn-sm" 
        style="margin-right:10px;"
        [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
